import axios from "axios";
import Cookies from "js-cookie";

const getToken = Cookies.get("token");

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  headers: {
    // 'ngrok-skip-browser-warning': true,
    Authorization: `Bearer ${
      getToken && JSON.parse(getToken.split("j:")[1]).token
    }`,
  },
});

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log("error info", error);

    if (error.response) {
      const status = error.response.status;
    }
    return Promise.reject(error);
  }
);

const responseBody = (response) => response.data;

const requests = {
  get: (url) => instance.get(url).then(responseBody),

  post: (url, body) => instance.post(url, body).then(responseBody),

  put: (url, body) => instance.put(url, body, {}).then(responseBody),

  delete: (url, config) => instance.delete(url, config).then(responseBody),
};

export const resource = {
  getResourceData: (
    page,
    sortField,
    sortOrder,
    filterField,
    search,
    skills,
    projects,
    selectTeam,
    employeeId,
    globalSearch
  ) => {
    const params = new URLSearchParams();

    if (page) params.append("page", page);
    if (sortField) params.append("sortField", sortField);
    if (sortOrder) params.append("sortOrder", sortOrder);
    if (filterField) params.append("filterField", filterField);
    if (search) params.append("search", search);
    if (skills.length > 0) params.append("skills", skills.join(","));
    if (projects.length > 0) params.append("projects", projects.join(","));
    if (selectTeam) params.append("team", selectTeam);
    if (employeeId) params.append("employeeId", employeeId);
    if (globalSearch) params.append("globalSearch", globalSearch);

    return requests.get(`/api/resource/get/all?${params.toString()}`);
  },
  getResourceDetails: (body) =>
    requests.post("/api/resource/get/employee/details", body),
  updateResourceDetails: (body) => requests.put("/api/resource/update", body),
  uploadEmployeeAttachment: (body) =>
    requests.post("/api/resource/create/employee/attachment", body),
  getEmployeeAttachment: (body) =>
    requests.post("/api/resource/get/employee/attachment", body),
  deleteEmployeeAttachment: (body) =>
    requests.post("/api/resource/delete/employee/attachment", body),
};

export const employee = {
  getEmployeeList: () => requests.get("/api/resource/get/employee"),
  getSkills: (query = "") => requests.get(`/api/resource/get/skills${query}`),
  getProjectList: () => requests.get("/api/resource/get/project/list"),
};

export const dashboard = {
  getBUWiseCount: (employeeId) => {
    const params = new URLSearchParams();
    if (employeeId) params.append("employeeId", employeeId);
    return requests.get(`/api/dashboard/get/team/count?${params.toString()}`);
  },

  utilizationByBUTeam: (employeeId, selectTeam) => {
    const params = new URLSearchParams();
    if (employeeId) params.append("employeeId", employeeId);
    if (selectTeam) params.append("team", selectTeam);
    return requests.get(
      `/api/dashboard/get/team/utilbybuteam?${params.toString()}`
    );
  },

  unBillableAndAvailableCount: (employeeId, selectTeam) => {
    const params = new URLSearchParams();
    if (employeeId) params.append("employeeId", employeeId);
    if (selectTeam) params.append("team", selectTeam);
    return requests.get(
      `/api/dashboard/get/team/nbacount?${params.toString()}`
    );
  },

  teamWiseExperience: (employeeId, selectTeam) => {
    const params = new URLSearchParams();
    if (employeeId) params.append("employeeId", employeeId);
    if (selectTeam) params.append("team", selectTeam);
    return requests.get(
      `/api/dashboard/get/team/experience?${params.toString()}`
    );
  },

  billableAndNonBillableCount: (employeeId, xPreviousMonth, selectTeam) => {
    const params = new URLSearchParams();
    if (employeeId) params.append("employeeId", employeeId);
    if (xPreviousMonth) params.append("xPreviousMonth", xPreviousMonth);
    if (selectTeam) params.append("team", selectTeam);
    return requests.get(
      `/api/dashboard/get/team/nonbillcount?${params.toString()}`
    );
  },

  TDEmployeeMovement: (employeeId, selectTeam) => {
    const params = new URLSearchParams();
    if (employeeId) params.append("employeeId", employeeId);
    if (selectTeam) params.append("team", selectTeam);
    return requests.get(
      `/api/dashboard/get/team/tdempmovement?${params.toString()}`
    );
  },

  attritionRate: (employeeId, timePeriod, selectTeam) => {
    const params = new URLSearchParams();
    if (employeeId) params.append("employeeId", employeeId);
    if (timePeriod) params.append("timePeriod", timePeriod);
    if (selectTeam) params.append("team", selectTeam);
    return requests.get(
      `/api/dashboard/get/team/attritionrate?${params.toString()}`
    );
  },
};
